import { ShieldAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import { Card, CardContent } from '@/components/ui/card';
import type { Role } from '@/stores/session';
import { usePermission } from './usePermission';

function PermissionDenied() {
  const { t } = useTranslation('common');
  return (
    <div className="mx-auto max-w-lg py-10">
      <Card>
        <CardContent className="text-muted-foreground flex flex-col items-center gap-3 py-14 text-center">
          <ShieldAlert className="size-8" />
          <p className="text-foreground font-medium">{t('permissionDenied.title')}</p>
          <p className="max-w-sm text-sm">{t('permissionDenied.description')}</p>
        </CardContent>
      </Card>
    </div>
  );
}

/**
 * Layout-route role guard: mounts its children only when the active membership
 * role matches; otherwise renders a friendly denial (in place, keeping the
 * shell). Example: the Settings route is wrapped in
 * `<Route element={<RequireRole roles={['admin']} />}>`.
 */
export function RequireRole({ roles }: { roles: Role[] }) {
  const { hasRole } = usePermission();
  if (!hasRole(...roles)) return <PermissionDenied />;
  return <Outlet />;
}
